const getEnvironment = () => {
  const envValue = (process.env.REACT_APP_ENV || 'local').toLowerCase();

  if (envValue === 'prod') {
    return 'production';
  }

  if (envValue === 'stage') {
    return 'staging';
  }

  if (envValue === 'dev') {
    return 'development';
  }

  return 'local';
};

export default getEnvironment;
